
import PinyinMatch from 'pinyin-match';
import { valueEquals } from 'element-ui/lib/utils/util';
import { objDeepCopy } from '@/utils';

export default {
  name: 'WkDep', // 新建 dep
  components: {},
  props: {
    headerShow: {
      type: Boolean,
      default: true
    },
    options: Array,
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 取值字段
    props: {
      type: Object,
      default: function _default() {
        return {
          value: 'id',
          label: 'name'
        };
      }
    },
    // 多选框 只能选一个
    radio: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dataValue: [],
      breadcrumbList: [], // 面包屑数据
      dataList: [], // 展示数据
      loading: false, // 加载动画
      searchInput: ''
    };
  },

  computed: {
    showDataList: function showDataList() {
      var _this = this;

      return this.dataList.filter(function (item) {
        return PinyinMatch.match(item[_this.props.label], _this.searchInput);
      });
    }
  },
  watch: {
    value: {
      handler: function handler() {
        if (!valueEquals(this.value, this.dataValue)) {
          this.dataValue = objDeepCopy(this.value);
          this.handelCheck(this.dataList);
        }
      },

      immediate: true
    },

    options: {
      handler: function handler() {
        this.initInfo();
      },

      immediate: true
    }
  },
  mounted: function mounted() {},

  methods: {
    initInfo: function initInfo() {
      this.dataList = this.options;
      this.breadcrumbList = [{ label: '全部', data: this.options }];

      // options获取默认执行一次
      this.dataValue = objDeepCopy(this.value);
      this.handelCheck(this.dataList);
    },


    /**
     * 面包屑点击事件
     */
    breadcrumbBtn: function breadcrumbBtn(item, index) {
      if (index + 1 <= this.breadcrumbList.length - 1) {
        this.breadcrumbList.splice(index + 1, this.breadcrumbList.length - 1);
      }
      this.dataList = [];
      this.dataList = this.handelCheck(item.data);
    },


    /**
     * 点击checkbox选中
     */
    checkChange: function checkChange(item, aindex) {
      var _this2 = this;

      // 单选逻辑
      if (this.radio) {
        if (item.isCheck && this.dataValue.length) {
          this.dataList.forEach(function (cItem) {
            if (cItem[_this2.props.value] !== item[_this2.props.value]) {
              cItem.isCheck = false;
            }
          });
        }
        this.dataValue = item.isCheck ? [item[this.props.value]] : [];
      } else {
        var removeIndex = -1;
        for (var index = 0; index < this.dataValue.length; index++) {
          var element = this.dataValue[index];
          if (item[this.props.value] == element) {
            removeIndex = index;
            break;
          }
        }
        if (removeIndex == -1 && item.isCheck) {
          this.dataValue.push(item[this.props.value]);
        } else if (removeIndex != -1) {
          this.dataValue.splice(removeIndex, 1);
        }
      }

      this.$emit('change', this.dataValue);
      this.$emit('input', this.dataValue);
    },


    /**
     * 数据重新刷新时 循环标记展示数组
     */
    handelCheck: function handelCheck(list) {
      var _this3 = this;

      list.forEach(function (item) {
        var isCheck = _this3.valueHasItem(item);
        if (isCheck !== item.isCheck) {
          item.isCheck = isCheck;
        }
      });
      return list;
    },
    valueHasItem: function valueHasItem(item) {
      if (this.dataValue.length == 0) {
        return false;
      }
      var hasItem = false;
      for (var index = 0; index < this.dataValue.length; index++) {
        var element = this.dataValue[index];
        if (item[this.props.value] == element) {
          hasItem = true;
          break;
        }
      }
      return hasItem;
    },


    /**
     * 点击进入子数组
     */
    enterChildren: function enterChildren(item) {
      // 保证单选环境下 没有选中 才可进入children
      if (item.children) {
        this.dataList = [];
        this.dataList = this.handelCheck(this.addIsCheckProp(item.children));
        this.breadcrumbList.push({ label: item[this.props.label], data: this.dataList });
      }
    },


    /**
     * 给默认数据加isCheck属性
     */
    addIsCheckProp: function addIsCheckProp(list) {
      if (list.length > 0) {
        var item = list[0];
        if (item.hasOwnProperty('isCheck')) {
          return list;
        } else {
          return list.map(function (item, index, array) {
            item.disabled = false;
            item.isCheck = false;
            item.show = true;
            return item;
          });
        }
      }
      return list;
    },
    clearAll: function clearAll() {
      this.dataValue = [];
      this.dataList = this.dataList.map(function (item) {
        item.isCheck = false;
        return item;
      });
      this.$emit('input', this.dataValue);
    }
  }
};